import orderBy from 'lodash/orderBy'

import { type EmojiName, emojiOrder } from '@portal/news-lib/emoji'

type EmojiStats = { name: EmojiName; count: number }[]

export const sortEmojiStats = (stats: Record<EmojiName, number>): EmojiStats => {
    const entries = Object.entries(stats) as [EmojiName, number][]

    return sortReactionsByCount(entries.map(([name, count]) => ({ name, count })))
}

const sortReactionsByCount = (reactions: EmojiStats) => {
    const reactionsWithOrder = reactions.map((reaction) => ({
        ...reaction,
        order: emojiOrder[reaction.name],
    }))

    return orderBy(reactionsWithOrder, ['count', 'order'], ['desc', 'asc'])
}
